<template>
  <BaseDialog
    title="Logs"
    v-model="showIntegrationLogDetail"
    width="90%"
    cardTextClass="px-4 pt-4"
  >
    <template #information>
      <v-row col="12">
        <v-col cols="3">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span>Trace ID</span>
              </div>
              <p>{{ LogData.trace_id }}</p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="2">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span>Status Code</span>
              </div>
              <p>{{ LogData.status_code }}</p>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="2">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span>Creation Date</span>
              </div>
              <p>{{ LogData.created.split(' ')[0] }}</p>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="2">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span>Creation Time</span>
              </div>
              <p>{{ LogData.created.split(' ')[1] }}</p>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="2">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span>Operation</span>
              </div>
              <p>{{ LogData.event == "update" ? "Update": "Create"  }}</p>
            </v-card-text>
          </v-card>
        </v-col>
        
      </v-row>
      <v-row col="12">
        <v-col cols="12">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span>Payload</span>
              </div>
              <JsonViewer :value="LogData.payload || {}" copyable></JsonViewer>
              <!-- <JsonViewer :value="{}" copyable></JsonViewer> -->
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row col="12">
        <v-col cols="6">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span>Headers</span>
              </div>
              <JsonViewer :value="LogData.headers || {}" copyable></JsonViewer>
              <!-- <JsonViewer :value="{}" copyable></JsonViewer> -->
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span>Response</span>
              </div>
              <JsonViewer :value="LogData.response || {}" copyable></JsonViewer>
              <!-- <JsonViewer :value="{}" copyable></JsonViewer> -->
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card outlined>
            <v-card-text>
              <div class="d-flex">
                <span>Errors</span>
              </div>
              <JsonViewer :value="LogData.error || {}" copyable></JsonViewer>
              <!-- <JsonViewer :value="{}" copyable></JsonViewer> -->
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- <v-row col="12" v-if="LogData.event_type != 'Telematics'">
          <v-col cols="12">
            <WebhookLogList
              :incomingWebhookLogId="webhookLogId"
              :isMainDialogOpen="value"
            />
          </v-col>
        </v-row> -->
    </template>
  </BaseDialog>
</template>
  
  <script>
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import JsonViewer from "vue-json-viewer";

export default {
  components: {
    BaseDialog,
    JsonViewer,
  },
  props: {
    value: {
      required: true,
      type: Boolean,
    },
    integrationId: {
      required: true,
    },
  },
  data() {
    return {
      LogData: {},
    };
  },
  computed: {
    showIntegrationLogDetail: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.getIntegrationLogsDetail();
      } else {
        // this.reset();
      }
    },
  },
  methods: {
    getIntegrationLogsDetail() {
      // this.$bus.$emit("showLoader", true);
      this.$api.integration
        .getIntegrationLogsDetail(this.integrationId)
        .then((res) => {
          // this.$bus.$emit("showLoader", false);
          this.LogData = res.data;
        })
        .catch((err) => {
          // this.$bus.$emit("showLoader", false);
          console.log(err);
        });
    },
  },
};
</script>
  
  <style></style>